import { makeStyles } from '@material-ui/core/styles';
import { DIMENSIONS } from './../../styles/constants';

export const useStyles = makeStyles(theme => ({
	tableBar: {
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'space-between',
		height: DIMENSIONS.SKELETON_TITLE_HEIGHT,
		padding: `${theme.spacing(1.5)}px ${theme.spacing(3)}px`,
		marginBottom: `${theme.spacing(2)}px`
	},
	header: {
		borderTopLeftRadius: '3px',
		borderTopRightRadius: '3px',
		backgroundColor: '#ecebeb',
		height: DIMENSIONS.NAVBAR_HEIGHT,
		padding: 0,
		margin: 0,
		border: 0
	},
	tableBarBottom: {
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'space-between',
		height: DIMENSIONS.SKELETON_TITLE_HEIGHT,
		padding: `${theme.spacing(1.5)}px ${theme.spacing(3)}px`,
		marginBottom: `${theme.spacing(3.5)}px`
	},
	tableRow: {
		height: DIMENSIONS.SKELETON_TABLE_ROW_HEIGHT
	},
	tableRowTitle: {
		height: DIMENSIONS.SKELETON_TITLE_HEIGHT
	},
	tableRowButton: {
		height: DIMENSIONS.SKELETON_BUTTON_HEIGHT
	},
	paper: {
		padding: '10px',
		marginTop: '10px',
		marginLeft: '26px',
		maxWidth: 1253,
		boxShadow: `inset 0px 0px 4px 0.4px #d1d1d1 `
	},
	skeleton: {
		margin: `${theme.spacing(1)}px ${theme.spacing(3)}px`
	},
	skeletonNarrow: {
		margin: `0 ${theme.spacing(3)}px`
	},
	firstColumn: {
		minWidth: '240px',
		paddingLeft: '7px',
		marginRight: theme.spacing(-5)
	},
	secondColumn: {
		minWidth: '240px',
		marginTop: theme.spacing(5.5),
		marginRight: theme.spacing(10)
	},
	thirdColumn: {
		paddingTop: '40px',
		minWidth: '260px',
		borderRadius: '4px',
		paddingBottom: '6px'
	},
	fourthColumn: {
		marginLeft: theme.spacing(2),
		display: 'flex',
		justifyContent: 'flex-end',
		minWidth: '200px',
		paddingRight: '5px'
	},
	evalButton: {
		textTransform: 'none',
		display: 'inline-block',
		alignSelf: 'flex-end',
		flexGrow: '1',
		marginRight: '4px'
	}
}));
